/*
 * EnvAuthenticatorStepThree Messages
 *
 * This contains all the text for the EnvAuthenticatorStepThree component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.EnvAuthenticatorStepThree";

export default defineMessages(scope, {
  header:
    "To set up, manually enter the secret when prompted in the authentication app you are using.",
  info: "*If prompted for an account name, create a memorable name and enter it in the provided field.",
  keyTextField: "Secret Key",
  nextButtonLabel: "Next",
  cancelButtonLabel: "Cancel",
});
